export default __webpack_public_path__ + "static/media/Olim10.d35472f4.png";